/**
 * @name RouteWithLayout
 * @description Override react route with layout
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';

// React Router
import { Route } from 'react-router-dom';

const RouteWithLayout = (props) => {
  const {
    layout: Layout,
    component: Component,
    state,
    ...restProps
  } = props;

  return (
    <Route
      {...restProps}
      render={(routeProps) => (
        state ? (
          <Layout {...state}>
            <Component {...routeProps} />
          </Layout>
        ) : (
            <Layout>
              <Component {...routeProps} />
            </Layout>
          )
      )}
    />
  );
};

RouteWithLayout.propTypes = {
  // Main layout.
  layout: PropTypes.any.isRequired,
  // Component.
  component: PropTypes.any.isRequired,
  state: PropTypes.object
};

export default RouteWithLayout;
